var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-card-title',{staticClass:"pl-0"},[_c('h2',{staticClass:"title pl-0"},[_vm._v("Home")])]),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('system-note-widget',{})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('my-orders-widget',{attrs:{"widgetConfiguration":{
          name: 'my-requests-widget',
          title: 'Work Orders',
          helplink:
            'https://docs.wizardsoftware.net/performo/v11/requester/300-requester#using-the-work-order-request-list',
          emptyMessage: 'You currently have no open requests.'
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }